module.exports = __webpack_public_path__ + "img/termohigrometro.ab6aae61.webp";